import Vue from 'vue'
import GAuth from 'vue-google-oauth2'
 
// Only initialize Google OAuth if clientId is provided
if (process.env.GOOGLE_CLIENT_ID) {
  const gauthOption = {
    clientId: process.env.GOOGLE_CLIENT_ID,
    scope: 'profile email',
    prompt: 'select_account'
  }
  Vue.use(GAuth, gauthOption)
} else {
  console.warn('[Google OAuth] GOOGLE_CLIENT_ID not set - Google OAuth disabled')
}